"use client";
import { memo, useEffect, useRef } from "react";
import { cn } from "utils";
import { getKolStatusOffsetHeight, stickyConfig } from "../stickyConfig";
import { useListData } from "./useListData";
import { UserCard } from "./UserCard";
import createInfiniteScroll from "./createInfiniteScroll";

export const KolStatus: React.FC = () => {
  const { data } = useListData();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (data && data?.length > 0) {
      const wrapper = wrapperRef.current!;
      const content = contentRef.current!;

      const infiniteScroll = createInfiniteScroll({
        scrollTrack: content,
        scrollContainer: wrapper,
        cardWidth: 296,
        duration: 5,
      });
      return () => {
        infiniteScroll.destroy();
      };
    }
  }, [data]);

  return (
    <div
      className={cn(
        "sticky before:content-[''] before:absolute before:left-0 before:w-[35px] before:h-[45px] before:bg-[linear-gradient(94deg,_#161616_18.87%,_rgba(22,22,22,0.00)_96.52%)] 96.52%)",
        " after:content-[''] after:absolute after:top-0 after:w-[35px] after:h-[45px] after:bg-[linear-gradient(94deg,_#161616_18.87%,_rgba(22,22,22,0.00)_96.52%)] after:z-10",
        "after:rotate-180 after:right-0",
      )}
      style={{
        height: stickyConfig.KolStatusHeight,
        top: getKolStatusOffsetHeight(),
      }}
    >
      <div
        className={cn(
          "flex-1 overflow-x-auto no-scrollbar bg-background_solid_secondary z-100 h-[fit-content] pr-28",
        )}
        ref={wrapperRef}
      >
        <div
          ref={contentRef}
          className="flex justify-start gap-3 w-[fit-content]"
        >
          {data?.map((item, index) => (
            <MemoizedUserCard
              className="MemoizedKolUserCard"
              key={`${item?.token_handle || ""}-${item?.name || ""}-${index}`}
              type={item?.type}
              timeStamp={item?.time}
              token={item?.token_handle}
              handle={item?.name}
              screenName={item?.screenName}
              postId={item?.post_id}
              icon={item?.profileImageUrlHttps}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// 使用 memo 包装 UserCard 组件
const MemoizedUserCard = memo(UserCard);

// 使用 memo 导出 KolStatus 组件
export const MemoizedKolStatus = memo(KolStatus);
